import { render, staticRenderFns } from "./ShareIcon.vue?vue&type=template&id=6db0a7f0&scoped=true&"
import script from "./ShareIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShareIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0a7f0",
  null
  
)

export default component.exports